<script lang="ts">
      import { getCachedAsset } from '$lib/utils/cache'
      import { renderTick } from '$lib/utils/flip'
      import { Result } from '$lib/utils/result'
      import { onMount } from 'svelte'
      import { on } from 'svelte/events'

      const event = ['load', 'ended', 'error', 'playing', 'loadeddata', 'loadstart', 'complete', 'canplaythrough', 'seeked', 'seeking', 'canplay']

      const statusEvents = ['ended', 'playing', 'seeking', 'seeked', 'canplaythrough', 'pause']

      async function handleEvent(e: Event) {
            //if (e.type == 'canplaythrough' && autoplay) play()
            //if (e.type == 'ended' && loop) seekToStart()
      }

      async function cacheVideo(url: string) {
            const response = await getCachedAsset(url)
            const blob = await response.blob()
            const urlObject = URL.createObjectURL(blob)
            return urlObject
      }

      export async function loadAsync() {
            if (!videoElement) return
            videoElement.pause()

            const ctrl = new AbortController()

            let _url = video
            if (cache) {
                  _url = await cacheVideo(video)
            }

            videoElement.src = _url

            videoElement.load()

            return new Promise((resolve, reject) => {
                  videoElement.addEventListener(
                        'canplay',
                        () => {
                              resolve(true)
                              ctrl.abort()
                        },
                        { signal: ctrl.signal }
                  )
                  videoElement.currentTime = 0
            })
      }

      export async function playAsync() {
            if (!videoElement) return
            videoElement.pause()

            const ctrl = new AbortController()

            on(videoElement, 'timeupdate', async () => {
              await renderTick()
              //await renderTick()
              showVideo()
            }, {
                  once: true,
            })


            return new Promise((resolve, reject) => {
                  videoElement.addEventListener(
                        'ended',
                        () => {
                              resolve(true)
                              ctrl.abort()
                        },
                        { signal: ctrl.signal }
                  )
                  videoElement.play()
            })
      }

      export function showVideo() {
            hidden = false
      }

      async function updateStatus(e: Event) {
            status = e.type
      }

      export function play() {
            console.log(paused)
            if (paused === undefined) return
            if (paused) return videoElement.play()
            return videoElement.pause()
      }

      async function playVideo() {
            await Result(() => loadAsync())

            await playAsync()

            if (loop) return playVideo()
      }

      function seekToStart() {
            videoElement.currentTime = 0
      }

      export function getElement() {
            return videoElement
      }

      export function isPlaying() {
            return !videoElement.paused
      }

      let abort: AbortController
      onMount(() => {
            videoElement.pause()
            if (muted) {
                  videoElement.muted = true
                  videoElement.setAttribute('muted', `true`)
            }
            abort = new AbortController()

            event.map((e) => {
                  videoElement.addEventListener(e, handleEvent, { signal: abort.signal })
            })

            statusEvents.map((e) => {
                  videoElement.addEventListener(e, updateStatus, { signal: abort.signal })
            })

            if (autoplay) {
                  Result(() => playVideo())
            }

            return () => abort.abort()
      })

      let { video = '', loop = false, autoplay = false, status = $bindable(), cache = false, muted = true } = $props()

      status = 'init'

      let videoElement: HTMLVideoElement

      let paused: boolean | null | undefined = $state(undefined)
      let _videoUrl = ''
      //let canplaythrough: boolean = $state(false)

      let hidden = $state(true)
</script>

<div class="w-full h-full absolute flex items-center justify-center {hidden ? 'opacity-0' : 'opacity-100'}">
      <!-- svelte-ignore a11y_media_has_caption -->
      <video src={_videoUrl} bind:paused bind:this={videoElement} class="mx-auto w-full h-auto md:w-auto md:h-full object-contain" disablePictureInPicture={true} muted playsinline> </video>
</div>

<style lang="postcss">
</style>
